// Packages
import React, { useState, useRef, useEffect, ReactElement } from 'react';

// Components
import { KiteIcon, KiteButton } from '@kite/react-kite';
import './ContextMenu.scss';

export interface IContextMenuProps {
  children: ReactElement[];
  buttonLabel?: string;
}

const ContextMenu = ({ children, buttonLabel }: IContextMenuProps) => {
  // =============================================
  // Helpers (Memo, CB, vars)
  // =============================================

  // =============================================
  // Return
  // =============================================

  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const handleMenuItems = (action: () => void) => {
    action();
    setOpenMenu(false);
  };

  const handleClick = (e: MouseEvent) => {
    e.stopPropagation();
    if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
      setOpenMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  return (
    <div className="menu-container">
      {buttonLabel ? (
        <KiteButton size="small">{buttonLabel}</KiteButton>
      ) : (
        <KiteIcon
          name="more-vert"
          size="30px"
          margin="0 0 0 4px"
          color="#0073d1"
          onClick={() => {
            setOpenMenu(!openMenu);
          }}
        />
      )}

      {openMenu && (
        <div className="menu" ref={menuRef}>
          <ul>
            {React.Children.map(children, (child) =>
              React.cloneElement(child, {
                onClick: () => handleMenuItems(child.props.onClick),
              })
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ContextMenu;
